import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createContext, type ReactNode, useContext } from 'react';
import type { ApiClient } from './client';

const ApiClientContext = createContext<ApiClient | null>(null);

/** Stellt Client und Abfrage-Zwischenspeicher bereit; Tests und die App setzen je ihre eigenen ein. */
export function ApiProvider({
  client,
  queryClient,
  children,
}: {
  client: ApiClient;
  queryClient: QueryClient;
  children: ReactNode;
}) {
  return (
    <ApiClientContext.Provider value={client}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ApiClientContext.Provider>
  );
}

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (client === null) {
    throw new Error('useApiClient muss innerhalb von ApiProvider verwendet werden');
  }
  return client;
}
